// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D5NG0elKBGcpA_6m4ELh {
  display: flex;
  height: 100%;
}
.D5NG0elKBGcpA_6m4ELh .cxiAUQ1uA6APvjOds9U1 {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/RightPanel/UnitPanel/components/Spreadsheets/styles.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,YAAA;AAAF;AAGA;EACE,YAAA;AADF","sourcesContent":["\n.container {\n  display: flex;\n  height: 100%;\n}\n\n.container .univer-theme {\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `D5NG0elKBGcpA_6m4ELh`,
	"univer-theme": `cxiAUQ1uA6APvjOds9U1`
};
export default ___CSS_LOADER_EXPORT___;
